module.exports = __webpack_public_path__ + "img/EstadoBateriaDispositivoInalambrico.3a91cd47.svg";